import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../services/api';
import { User } from '../types/user';

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
  fetchUser: () => Promise<void>;
  updateProfile: (profileInfo: any) => Promise<void>; // Legacy method for backward compatibility
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,

      login: (token: string) => {
        set({ token, isAuthenticated: true });
        get().fetchUser();
      },

      logout: () => {
        set({ token: null, user: null, isAuthenticated: false });
      },

      fetchUser: async () => {
        if (!get().token) return;
        try {
          // Use the new profile endpoint for enhanced profile data
          const response = await api.get('/users/me/profile');
          set({ user: response.data });
        } catch (error) {
          console.error('Failed to fetch user', error);
          get().logout(); // Log out if token is invalid
        }
      },

      updateProfile: async (profileInfo: any) => {
        if (!get().token) return;
        try {
          // Use the legacy endpoint for backward compatibility
          const response = await api.put('/users/me', { profile_info: profileInfo });
          set({ user: response.data });
        } catch (error) {
          console.error('Failed to update profile', error);
          throw error;
        }
      },
    }),
    {
      name: 'auth-storage', // name of the item in the storage (must be unique)
      getStorage: () => localStorage, // (optional) by default, 'localStorage' is used
    }
  )
);